var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgResizeNwse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#FFFFFF",
    strokeWidth: 4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5 5l14 14M5 5v5M5 5h5M19 19v-5M19 19h-5"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    stroke: "#1D1D1D",
    strokeWidth: 1.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5 5l14 14M5 5v5M5 5h5M19 19v-5M19 19h-5"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResizeNwse);
export default __webpack_public_path__ + "static/media/resize_nwse.a4a16ae74e668f27dadd755e6d0184b1.svg";
export { ForwardRef as ReactComponent };